import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Nature } from './nature.model';
import { NatureClientService } from '../../../../core/services/nature-client.service';
import { INatures } from '../../../../core/models/nature.model';
import { InlineResponse } from '../../../../core/models/inline-response.model';

@Injectable({
  providedIn: 'root',
})
export class ReferentialsNaturesService {
  constructor(private natureClientService: NatureClientService) {}

  getNatureData(): Observable<Nature[]> {
    return this.natureClientService.getNatureData().pipe(
      map((nature) => nature.rows),
      map((rows) => rows.map((row) => new Nature(row.codeHecate, row.designation, row.id))),
    );
  }

  addNatureData(codeHecate: number, designation: string): Observable<InlineResponse> {
    return this.natureClientService.saveNatureData(codeHecate, designation);
  }

  editNatureData(nature: Nature): Observable<InlineResponse> {
    return this.natureClientService.editNatureData(nature);
  }
}
